module.exports = __webpack_public_path__ + "img/reportedcoupons-active.512626d4.svg";